import { excuseApi } from '../commons/http';

const REPORT_PATHS = {
  inventory: '/reports/inventory',
  order_items: '/reports/order_items',
  work_hours: '/reports/work-hours',
  order_staff_activity: '/reports/order_staff_activity',
  order_count: '/reports/order_count',
  subscription_health: '/reports/subscription-health',
  monthly_churn: '/reports/monthly-churn',
  revenue: '/reports/revenue',
};

export class Report {
  static getYesterdayDateRange() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const start = new Date(yesterday);
    start.setHours(0, 0, 0, 0);

    const end = new Date(yesterday);
    end.setHours(23, 59, 59, 999);

    const formatDate = (date) => {
      return date.toISOString();  // Gets YYYY-MM-DD format
    };

    return {
      start_date: formatDate(start),
      end_date: formatDate(end)
    };
  }

  static async fetch(reportName, params = {}) {
    if (!REPORT_PATHS[reportName]) {
      throw new Error(`Unknown report type: ${reportName}`);
    }

    try {
      const response = await excuseApi({
        path: REPORT_PATHS[reportName],
        method: 'GET',
        params: params,
      });
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching ${reportName} report:`, error);
      throw error;
    }
  }
}
